var Handlebars = require("/home/jenkins/workspace/朵颐 - 发布POS前台/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression;

  return "<li class=\""
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.active : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n    <a href=\"#billtab-"
    + alias3(alias2((depth0 != null ? depth0.cid : depth0), depth0))
    + "\" data-cid=\""
    + alias3(alias2((depth0 != null ? depth0.cid : depth0), depth0))
    + "\" data-toggle=\"tab\" data-status=\""
    + alias3(alias2(((stack1 = (depth0 != null ? depth0.billStatus : depth0)) != null ? stack1.code : stack1), depth0))
    + "\" class=\""
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.paid : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.refunded : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\"><span class=\"bill-index\">"
    + alias3(alias2((depth0 != null ? depth0.index : depth0), depth0))
    + "</span>&nbsp;<span class=\"status-text\">\n    "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.refunded : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.program(10, data, 0),"data":data})) != null ? stack1 : "")
    + "\n         ("
    + alias3(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/formatDate.js")).call(alias1,(depth0 != null ? depth0.lastUpdated : depth0),"time",{"name":"formatDate","hash":{},"data":data}))
    + ")\n    </span></a>\n    "
    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.paid : depth0),{"name":"unless","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n</li>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "active";
},"4":function(container,depth0,helpers,partials,data) {
    return "status-paid";
},"6":function(container,depth0,helpers,partials,data) {
    return "status-refunded";
},"8":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"pos.bill.status.Cancel",{"name":"i18n","hash":{},"data":data}));
},"10":function(container,depth0,helpers,partials,data) {
    var stack1;

  return container.escapeExpression(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? depth0.billStatus : depth0)) != null ? stack1.code : stack1),{"name":"i18n","hash":{},"data":data}));
},"12":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.webTable : depth0),{"name":"unless","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<button class=\"btn btn-default add-item "
    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.active : depth0),{"name":"unless","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" >"
    + container.escapeExpression(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(alias1,"pos.quickSetting.menu.additem",{"name":"i18n","hash":{},"data":data}))
    + "</button>";
},"14":function(container,depth0,helpers,partials,data) {
    return "hidden";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.bills : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/table/listItem.handlebars
// module id = 561
// module chunks = 0